import * as dateFns from "date-fns"
import React, { useEffect, useState } from "react"

type TimerProps = {
  startAt: Date
  now?: Date
  format?: string
  liveUpdate?: boolean
}

const Timer = (props: TimerProps) => {
  const {
    startAt,
    format = "mm:ss",
    now: initialNow = new Date(),
    liveUpdate,
  } = props

  const [now, setNow] = useState(initialNow.getTime())

  const difference = now - startAt.getTime()
  const differenceAsDate = new Date(difference)

  useEffect(() => {
    if (liveUpdate) {
      const interval = setInterval(() => setNow(Date.now()), 500)
      return () => {
        clearInterval(interval)
      }
    } else {
      setNow(initialNow.getTime())
    }
  }, [liveUpdate, initialNow])

  return <>{dateFns.format(differenceAsDate, format)}</>
}

export { Timer }
